import { plainToClassFromExist } from "class-transformer";
import { ResponseModel } from "@/models/classes/response";
import { ResponsesModel } from "@/models/classes/responses";
import { ReportDashboardTargetApi } from '@/services/api/report/dashboard_target';
import { OptionModel } from "@/models/classes/option";
import { BasicInfoModel, TargetDashboardModel } from "@/models/classes/report/dashboard_target";

const api = new ReportDashboardTargetApi();

export class ReportDashboardTargetService {
  // Get employee filter options
  getEmployeeFilter = async () => {
    try {
      const resp = await api.getEmployeeFilter();
      if (resp) {
        const resModel = plainToClassFromExist(
          new ResponsesModel<OptionModel>(OptionModel),
          resp
        );
        if (resModel.status === 200 && Array.isArray(resModel.data)) {
          return resModel.data;
        }
      }
      return [];
    } catch (error) {
      console.error('Error fetching employee filter:', error);
      return [];
    }
  };

  // Get basic dashboard info
  getBasicInfo = async () => {
    try {
      const resp = await api.getBasicInfo();
      if (resp) {
        const resModel = plainToClassFromExist(
          new ResponseModel<BasicInfoModel>(BasicInfoModel),
          resp
        );
        if (resModel.status === 200 && resModel.data) {
          return resModel.data;
        }
      }
      return null;
    } catch (error) {
      console.error('Error fetching basic info:', error);
      return null;
    }
  };

getTargetData = async (params: { employeeId?: string; searchText?: string } = {}) => {
  try {
    const resp = await api.getTargetData(params);
    if (resp) {
      const resModel = plainToClassFromExist(
        new ResponsesModel<TargetDashboardModel>(TargetDashboardModel),
        resp
      );
      if (resModel.status === 200 && Array.isArray(resModel.data)) {
        return resModel.data;
      }
    }
  } catch (error) {
    console.error('Error fetching target dashboard data:', error);
    return null;
  }
};
}
